var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 224,
    viewBox: "0 0 252 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    y: 39.938,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    y: 80.7442,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    y: 123.287,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    y: 165.829,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9927,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1455,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 105.382,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 192.436,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 241.004,
    y: 212.713,
    width: 10.9964,
    height: 11.2868,
    fill: "#EB6060",
    fillOpacity: 0.78
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.80ea830f0c3de3aac3f59a012474d899.svg";
export { ForwardRef as ReactComponent };